module.exports = __webpack_public_path__ + "static/media/ArboreumLogoDark.bd2a739c.svg";